export default __webpack_public_path__ + "static/media/Maintenance.edad2e0f.svg";